"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setFunFactsFail = exports.setFunFactsSuccess = exports.setFunFacts = exports.setRoleFail = exports.setRoleSuccess = exports.setRole = exports.setNameFail = exports.setNameSuccess = exports.setName = exports.setPhoneFail = exports.setPhoneSuccess = exports.setPhone = exports.setAvatarFail = exports.setAvatarSuccess = exports.setAvatar = exports.deleteAvatarFail = exports.deleteAvatarSuccess = exports.deleteAvatar = exports.getSettingsFail = exports.getSettingsSuccess = exports.getSettings = void 0;

var _reduxAct = require("redux-act");

var PREFIX = 'COMMON/PROFILE_SETTINGS/GENERAL';
var getSettings = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_SETTINGS_REQUEST"));
exports.getSettings = getSettings;
var getSettingsSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_SETTINGS_SUCCESS"));
exports.getSettingsSuccess = getSettingsSuccess;
var getSettingsFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/GET_SETTINGS_FAIL"));
exports.getSettingsFail = getSettingsFail;
var deleteAvatar = (0, _reduxAct.createAction)("".concat(PREFIX, "/DELETE_AVATAR_REQUEST"));
exports.deleteAvatar = deleteAvatar;
var deleteAvatarSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/DELETE_AVATAR_SUCCESS"));
exports.deleteAvatarSuccess = deleteAvatarSuccess;
var deleteAvatarFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/DELETE_AVATAR_FAIL"));
exports.deleteAvatarFail = deleteAvatarFail;
var setAvatar = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_AVATAR_REQUEST"));
exports.setAvatar = setAvatar;
var setAvatarSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_AVATAR_SUCCESS"));
exports.setAvatarSuccess = setAvatarSuccess;
var setAvatarFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_AVATAR_FAIL"));
exports.setAvatarFail = setAvatarFail;
var setPhone = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_PHONE_REQUEST"));
exports.setPhone = setPhone;
var setPhoneSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_PHONE_SUCCESS"));
exports.setPhoneSuccess = setPhoneSuccess;
var setPhoneFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_PHONE_FAIL"));
exports.setPhoneFail = setPhoneFail;
var setName = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_NAME_REQUEST"));
exports.setName = setName;
var setNameSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_NAME_SUCCESS"));
exports.setNameSuccess = setNameSuccess;
var setNameFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_NAME_FAIL"));
exports.setNameFail = setNameFail;
var setRole = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_ROLE_REQUEST"));
exports.setRole = setRole;
var setRoleSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_ROLE_SUCCESS"));
exports.setRoleSuccess = setRoleSuccess;
var setRoleFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_ROLE_FAIL"));
exports.setRoleFail = setRoleFail;
var setFunFacts = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_FUN_FACTS_REQUEST"));
exports.setFunFacts = setFunFacts;
var setFunFactsSuccess = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_FUN_FACTS_SUCCESS"));
exports.setFunFactsSuccess = setFunFactsSuccess;
var setFunFactsFail = (0, _reduxAct.createAction)("".concat(PREFIX, "/SET_FUN_FACTS_FAIL"));
exports.setFunFactsFail = setFunFactsFail;